import React from "react";
import { Avatar, Badge } from "@mui/material";
import { styled } from "@mui/material/styles";

import AttachFileIcon from "@mui/icons-material/AttachFile";

import PORTTheme from "../../../../themes/PORTTheme";
import ResourceIcon from "./ResourceIcon";

const avatarStyle = {
    backgroundColor: PORTTheme.palette.primary.main,
    color: "#FFF",
};

const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        height: 24,
        width: 24,
        borderRadius: "50%",
        backgroundColor: "#44b700",
        color: "#44b700",
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        border: `1px solid ${theme.palette.background.paper}`,
        padding: "0 4px",
    },
}));

const ResourceAvatar = React.forwardRef(function ResourceAvatar(props, ref) {
    const { fileMimeType, associationCount, disabled, ...rest } = props;

    let display = (
        <div {...rest} ref={ref}>
            <IconAvatar fileMimeType={fileMimeType} disabled={disabled} />
        </div>
    );

    if (associationCount > 0) {
        display = (
            <StyledBadge
                {...rest}
                ref={ref}
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                    <AttachFileIcon
                        alt="Associated"
                        sx={{ fontSize: 16, color: "#FFFFFF" }}
                    />
                }
            >
                <IconAvatar fileMimeType={fileMimeType} disabled={disabled} />
            </StyledBadge>
        );
    }

    return display;
});

const IconAvatar = ({ fileMimeType = null, disabled = false }) => {
    const opacity = disabled ? 0.38 : 1;

    return (
        <Avatar
            aria-label="Resource"
            style={{ ...avatarStyle, opacity: opacity }}
            sx={{ width: 52, height: 52, marginRight: "4px" }}
        >
            <ResourceIcon fileMimeType={fileMimeType} />
        </Avatar>
    );
};

export default ResourceAvatar;
